module.exports = __webpack_public_path__ + "static/img/howtograpevine.b160735.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/howtograpevine.png
// module id = f8Ar
// module chunks = 1